// LemmaParseHeadUtils.js (updated with support for lemma_chs expanded details)
import React, { useState } from 'react';
import { SpeakTextButton,LemmaAudioPlayer } from './LemmaPlayUtils';
import './LemmaParseHeadUtilstyle.css';

const CmnLemmaDisplay = ({ lemmashead, lemmachs = '[]',headword, showlemma,langcodename}) => {
  const [tempShow, setTempShow] = useState(false);
  const [showMore, setShowMore] = useState(false);

  if (!lemmashead) return null;

  const parse_head = (lemmasHead) => {
    let parsedHead = [];
    try {
      parsedHead = JSON.parse(lemmasHead);
    } catch (error) {
      console.error("Error parsing lemmasHead:", error);
      return <div>Invalid lemmashead format.</div>;
    }

    if (!Array.isArray(parsedHead)) {
      return <div>No lemma lemmashead available.</div>;
    }
   // console.log('The entire parsedHead array:', parsedHead); // Assuming parsedHead is defined
    return parsedHead.map(({subject_pos, definition2, definition2_chs }, index) => (
      <div key={index} className="mb-2">
        <div><strong>{index + 1}:</strong> {subject_pos}</div>
        {definition2_chs && ( 
        <div class="en-def"><strong></strong> {definition2_chs.value}

          <LemmaAudioPlayer aidurl={definition2_chs.aid} aidtext={definition2_chs.value} />
        </div>
        )}
      </div>
    ));
  };

 //keep the parameters order as it was from parseHeadwordExamplesWithChs
 //set first parameter examples_def = examples_def_chs as we don't have examples_def in cmn
  const parseCmnHeadwordExamplesWithChs = (examples_def = [], examples_def_chs = [], headword = '') => {
    if (!Array.isArray(examples_def) || examples_def.length === 0 || !headword) return null;
  
    const lowerHeadword = headword.toLowerCase();
    // Find matched indexes
    const matchedIndexes = examples_def
      .map((example, idx) => example.value.toLowerCase().includes(lowerHeadword) ? idx : -1)
      .filter(idx => idx !== -1);
  
    if (matchedIndexes.length === 0) return null;
  
    return (
      <div className="ld-examples">
        {/* <strong>Examples:</strong> */}
        <ul>
          {matchedIndexes.map((idx) => (
            <li key={idx}>
              {/* English example */}
              {examples_def[idx].value}
              <LemmaAudioPlayer aidurl={examples_def[idx].aid} aidtext={examples_def[idx].value} />
              {/* Mandarin example if exists */}
              {examples_def_chs[idx] && (
                <>
                  <div style={{ marginTop: '4px', color: '#666' }}>
                    {examples_def_chs[idx].value}
                    <LemmaAudioPlayer aidurl={examples_def_chs[idx].aid} aidtext={examples_def_chs[idx].value} />
                  </div>
                </>
              )}
            </li>
          ))}
        </ul>
      </div>
    );
  };

  const parse_lemma_chs = (lemmaChsData) => {
    let parsed = [];
    try {
      parsed = JSON.parse(lemmaChsData);
    } catch (error) {
      console.error("Error parsing lemma_chs:", error);
      return <div>Invalid more lemma data.</div>;
    }

    if (!Array.isArray(parsed)) {
      return <div>No additional lemma data.</div>;
    }

    parsed.sort((a, b) => {
      const aSub = (a.subject || '').split('.')[0];
      const bSub = (b.subject || '').split('.')[0];
      return aSub.localeCompare(bSub);
    });

    return parsed.map((item, index) => (
      <div key={`chs-${index}`} className="ld-expanded-block">
        <div><strong>{index + 1}:</strong> {(item.subject || '').split('.')[0]}</div>
         {/* {langcodename === 'eng' && (
        <div><strong>Def(EN):</strong> {item.definition}
          <LemmaAudioPlayer aidurl={item.definition2.aid} aidtext={item.definition2.value} />
        </div>
         )} */}
        {item.definition2_chs && (  
        <div class="en-def"><strong></strong> {item.definition_chs}
          <LemmaAudioPlayer aidurl={item.definition2_chs.aid} aidtext={item.definition2_chs.value} />
        </div>
        )}
        {parseCmnHeadwordExamplesWithChs(item.examples_def_chs,item.examples_def,headword)}
      </div>
    ));
  };

  return (
<div className="spStoreAddress">
  {(showlemma === 1 || tempShow) ? (
    <>
      {parse_head(lemmashead)}
      
      {/* --- THIS IS THE NEW UNIFIED BUTTON --- */}
      <button 
        className={`ld-show-more-btn ${showMore ? 'expanded' : ''}`} 
        onClick={() => setShowMore(!showMore)}
      >
        <span>{showMore ? 'Show less' : 'Show more'}</span>
        <i className="chevron"></i>
      </button>

      {/* This part remains the same: it only shows when showMore is true */}
      {showMore && parse_lemma_chs(lemmachs)}
    </>
  ) : (
    // We can style this initial "click to show" prompt to be consistent too
    <div className="blurred-lemma" onClick={() => setTempShow(true)}>
      Enable lemma
    </div>
  )}
</div>
  );
};

export default CmnLemmaDisplay;
